var _g, _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_11636_54583)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55.0006,
    r: 45,
    fill: "url(#paint0_radial_11636_54583)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55.0006,
    r: 45,
    fill: "url(#paint1_linear_11636_54583)",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 60.2092V40.6342C40 40.2842 40.1625 39.9342 40.4875 39.5842C40.8125 39.2342 41.15 39.0592 41.5 39.0592H60.9625C61.3375 39.0592 61.6875 39.228 62.0125 39.5655C62.3375 39.903 62.5 40.2592 62.5 40.6342V53.9842C62.5 54.3342 62.3375 54.6842 62.0125 55.0342C61.6875 55.3842 61.3375 55.5592 60.9625 55.5592H46L40.975 60.5842C40.8 60.7592 40.5937 60.803 40.3562 60.7155C40.1187 60.628 40 60.4592 40 60.2092ZM42.25 41.3092V53.3092V41.3092ZM47.5375 63.0592C47.1875 63.0592 46.8438 62.8842 46.5063 62.5342C46.1688 62.1842 46 61.8342 46 61.4842V57.8092H64.75V45.0592H68.5C68.85 45.0592 69.1875 45.2342 69.5125 45.5842C69.8375 45.9342 70 46.2967 70 46.6717V67.6717C70 67.9217 69.8813 68.0905 69.6438 68.178C69.4063 68.2655 69.2 68.2217 69.025 68.0467L64.0375 63.0592H47.5375ZM60.25 41.3092H42.25V53.3092H60.25V41.3092Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8312 11.6609C53.8312 10.7439 53.0875 9.99728 52.1713 10.0325C44.0839 10.343 36.2271 12.9175 29.4799 17.486C22.2719 22.3664 16.6539 29.3032 13.3364 37.4191C10.019 45.535 9.15097 54.4655 10.8422 63.0812C12.4254 71.1464 16.1845 78.5967 21.6867 84.6113C22.3073 85.2896 23.3659 85.2876 24.0117 84.6332C24.6455 83.991 24.6428 82.9608 24.0351 82.2938C18.9741 76.7394 15.5156 69.8689 14.0561 62.4334C12.4913 54.4618 13.2944 46.1989 16.3639 38.6898C19.4333 31.1807 24.6313 24.7625 31.3004 20.2469C37.5087 16.0434 44.7322 13.6643 52.1713 13.3556C53.0874 13.3175 53.8312 12.5778 53.8312 11.6609Z",
    fill: "url(#paint2_linear_11636_54583)",
    fillOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_11636_54583",
    x: 0,
    y: 0.000610352,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0823529 0 0 0 0 0.196078 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_11636_54583"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_11636_54583",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11636_54583",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55 55.0006) rotate(89.2559) scale(45.0038)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BB85E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762092,
    stopColor: "#0D116B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#050541"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11636_54583",
    x1: 28.7013,
    y1: 19.9357,
    x2: 52.6623,
    y2: 54.4162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7E61D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7E62D3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11636_54583",
    x1: 53.8312,
    y1: 10.0006,
    x2: 25.7877,
    y2: 86.8742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/feedback.db9ec7ab5fab605a26f88e5efbf584aa.svg";
export { ForwardRef as ReactComponent };